import COMPONENT_MAP from '../Repository/Components.js';

const TaskDetailEmployeesPopup=({popupCallBack,rowId,parent,userData,application})=>{

    const pageCallback=async(action,args)=>{
        popupCallBack(action,args);
    }

    const renderPageDetail=()=>{
        const Component=COMPONENT_MAP['PageDetail'];
        return Component?(
            <Component
                recordId={rowId}
                userData={userData}
                application={application}
                entityType={'TaskSystemUser'}
                entityParams={['_context='+['parent_field_name='+parent.parent_field_name,'parent_field_value='+parent.parent_field_value,'parent_name='+parent.parent_name],'_lang='+application.globalData.lang]}
                file={'TaskDetailEmployeesPopup.js'}
                titleLabel={rowId?application?.getLocale("PageTabTaskHours"):application?.getLocale("PageTabTaskHours")}
                pageCallback={pageCallback}
                pageTabs={[]}
                isPopUp={true}
                openOnUpdate={true}
            />
        ):null;
    };
    return (renderPageDetail());
}

export default TaskDetailEmployeesPopup;